<template>
  <div @click="click">
    <v-list-item :to="{ name: `${to}` }">
      <v-list-item-icon v-if="icon !== ''">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" class="nav-icon-inactive text">
              {{ icon }}
            </v-icon>
          </template>
          <span>{{ $t(text) }}</span>
        </v-tooltip>
      </v-list-item-icon>

      <v-list-item-title class="text">{{ $t(text) }}</v-list-item-title>

      <v-list-item-action>
        <v-btn class="budge-count" v-if="budge" x-small icon color="primary">
          <span color="grey lighten-1">{{ budge }}</span>
        </v-btn>
      </v-list-item-action>
    </v-list-item>
  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      value: "",
    },
    icon: {
      type: String,
      value: "",
    },
    budge: {
      type: [String, Number],
      value: "",
    },
    to: {
      type: String,
      value: "",
    },
  },
  methods: {
    click() {
      if (this.to == "") {
        this.$emit("click", this.text);
      }
    },
  },
};
</script>

<style>
.budge-count {
  background: #b3b3b3a2;
  color: white !important;
  font-size: 0.85rem !important;
}
</style>